import { poOpenOrder } from '@/utils/shared'

export const ListConfig = (orderBy) => ({
  isAutoLoad: false,
  isAsyncGet: true,
  store: {
    get: {
      url: 'RepairExchangeOrderFollowUps/GetAllDynamic',
      selected: [
        'id',
        'baxpo', 'reminderDate', 'partID', 'partSN', 'orderPhaseID', 'phaseDate',
        'phasePersonInChargeEmployeeID', 'lastInfo', 'shipped', 'shippedDate', 'quoteReceived', 'quoteReceivedDate',
        'quoteApproved', 'quoteApprovedDate', 'unitShipped', 'unitShippedDate', 'standby', 'standbyDate',

        'rfq.id as rfqID',
        'rfq.rfqid as rfqid',
        'rfq.po',
        'rfq.customerCompanyID',
        'rfq.customerContactID',
        'rfq.rfqTypeID',
        'rfq.baxEmployeeID',
        'rfq.poDate',
        'rfq.requestedDate',
        'rfq.pOIsOpen as poIsOpen',
        'rfq.observation',

        'rfq2.id as rfq2ID',
        'rfq2.supplierCompanyID',
        'rfq2.supplierContactID',
        'rfq2.conditionID',
        'rfq2.currencyID',
        'rfq2.estimatedDeliveryDate',
        'rfq2.receivedDate', 'rfq2.price',
        'rfq.salesOrders.Select(s => new { s.id, s.shippingPorformaNumber, s.awb, s.poStillOpen, s.remarks }) as salesOrders'
      ],
      filters: '(baxpo==null)?(1==2):(baxpo.StartsWith("W"))',
      orderBy: poOpenOrder(orderBy),
      expand: true
    },
    create: {
      url: 'RepairExchangeOrderFollowUps/Create'
    },
    patch: {
      url: (data) => `RepairExchangeOrderFollowUps/Patch/${data.id}`
    },
    delete: {
      url: (data) => `RepairExchangeOrderFollowUps/Delete/${data.id}`
    }
  },
  autoSave: {
    url: (data) => `RepairExchangeOrderFollowUps/Patch/${data.id}`
  },
  header: {
    isVisible: false
  },
  content: {
    isScroll: false
  },
  export: {
    excel: {
      // eslint-disable-next-line no-template-curly-in-string
      name: "${root.L10n('open-wo')}",
      columns: [
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('supplier')}",
          field: 'supplierCompanyName',
          width: 25
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('baxpo')}",
          field: 'baxpo'
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('supplier-contact')}",
          field: 'supplierContactName',
          width: 25
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('part-number')}",
          field: 'partNumber',
          width: 20
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('part-SN')}",
          field: 'partSN'
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('price')}",
          field: 'price'
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('currency')}",
          field: 'currencyTitle'
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('condition')}",
          field: 'conditionTitle'
        }
      ]
    }
  },
  controls: {
    isVisible: false
  },
  footer: {
    isVisible: true,
    pagination: {
      isVisible: true,
      size: 5,
      sizes: {
        isVisible: true,
        values: [
          { label: 3, value: 3 },
          { label: 5, value: 5 },
          { label: 10, value: 10 },
          { label: 20, value: 20 }
        ]
      }
    }
  }
})
